export var DEFAULT_AUDIENCES_CONFIG = {
  isUserAuthenticated: null,
  isCookieBannerVisible: null,
  locale: null
};
export var DISMISS_ACTIVE_BANNER_EVENT_NAME = 'tf_dismiss_active_banner';